const initialState = {
  activeStep: 0,
  manufacturer: null,
  vcpRoles: [],
  influencerRoles: [],
  rolesLoading: false,
  isInfluencerSelected: false,
  selectedRole: null,
  userDetails: {
    name: "",
    mobileNumber: "",
  },
  kycDetails: null,
  kycMethod: null, // 'DIGILOCKER' | 'AADHAAR_OCR' | 'AADHAAR_MANUAL' | 'GST'
  aadhaarResume: null, // 'upload' | 'manual' — reopen this Aadhaar sub-screen on step-1 mount
  manualDraft: null, // saved Aadhaar-manual form values, to re-prefill the manual form
};

const onboardBuyerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ONBOARD_ACTIVE_STEP":
      return { ...state, activeStep: action.payload };

    case "SET_BUYER_ROLES_LOADING":
      return { ...state, rolesLoading: action.payload };

    case "SET_BUYER_ROLES_DATA":
      return {
        ...state,
        manufacturer: action.payload.manufacturer,
        vcpRoles: action.payload.vcpRoles,
        influencerRoles: action.payload.influencerRoles,
      };
    case "SELECT_VCP_ROLE":
      return {
        ...state,
        selectedRole: action.payload,
        isInfluencerSelected: false,
      };
    case "TOGGLE_INFLUENCER":
      return {
        ...state,
        isInfluencerSelected: action.payload,
        selectedRole: null,
      };

    case "SELECT_INFLUENCER_ROLE":
      return { ...state, selectedRole: action.payload };

    case "CLEAR_SELECTED_ROLE":
      return { ...state, selectedRole: null };

    case "SET_USER_DETAIL_FIELD":
      return {
        ...state,
        userDetails: {
          ...initialState.userDetails,
          ...state.userDetails,
          [action.payload.field]: action.payload.value,
        },
      };

    case "SET_KYC_DETAILS":
      return { ...state, kycDetails: action.payload };

    case "SET_KYC_METHOD":
      return { ...state, kycMethod: action.payload };

    case "SET_AADHAAR_RESUME":
      return { ...state, aadhaarResume: action.payload };

    case "SET_MANUAL_DRAFT":
      return { ...state, manualDraft: action.payload };

    case "UPDATE_KYC_DETAILS":
      return {
        ...state,
        kycDetails: { ...state.kycDetails, ...action.payload },
      };

    case "RESET_ONBOARD_BUYER":
      return initialState;

    default:
      return state;
  }
};

export default onboardBuyerReducer;
